module.exports = __webpack_public_path__ + "img/banner.29866492.png";